import React from 'react';
import config from '../config';
import ProductCard from '../components/ProductCard';
import SectionReveal from '../components/SectionReveal';
import './Menu.css';

function Menu() {
  return (
    <main className="menu-page">
      <section className="page-hero page-hero--menu">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">Monthly Plans</span>
            <h1>Our Subscription Plans</h1>
            <p>Fresh fruit bowls delivered daily. No added sugar, zero preservatives. Choose your plan.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="menu-products-grid">
            {config.products.map((product, idx) => (
              <SectionReveal key={product.id} delay={idx * 0.15}>
                <ProductCard product={product} featured={idx === 1} />
              </SectionReveal>
            ))}
          </div>

          {/* Trial Note */}
          <SectionReveal delay={0.5}>
            <div className="menu-trial-note">
              <p className="menu-trial-note__text">
                Not sure yet? <strong>Book a 1 day paid trial drop - ₹99 !!!</strong>
              </p>
              <a
                href={config.getWhatsAppTrialUrl('')}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary menu-trial-note__btn"
              >
                Book Trial Drop
              </a>
            </div>
          </SectionReveal>
        </div>
      </section>
    </main>
  );
}

export default Menu;
